import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
  {
    path: '/HomePage', // 客服中心首页
    name: 'HomePage',
    meta: {
      desc: '转转客服中心',
      pageId: 'V7126',
      level: 2
    },
    component: () => import(/* webpackChunkName: "HomePage" */ '../views/HomePage/index.vue')
  },
  {
    path: '/QADetail', // 客服中心首页
    name: 'QADetail',
    component: () => import(/* webpackChunkName: "QADetail" */ '../views/QADetail/index.vue'),
    meta: {
      auth: true // 增加登录校验
    }
  },
  {
    path: '/KnowledgeDetail', // 知识库详情
    name: 'KnowledgeDetail',
    component: () => import(/* webpackChunkName: "KnowledgeDetail" */ '../views/KnowledgeDetail/index.vue'),
    meta: {
      auth: true // 增加登录校验
    }
  },
  {
    path: '/VideoList', // 视频流
    name: 'VideoList',
    component: () => import(/* webpackChunkName: "VideoList" */ '../views/VideoList/index.vue')
  },
  {
    path: '/invoiceList', // 发票列表页
    name: 'InvoiceList',
    meta: {
      pageId: 'E1692'
    },
    component: () => import(/* webpackChunkName: "InvoiceList" */ '../views/InvoiceList/index.vue')
  },
  {
    path: '/testPrerender', // 客服中心首页
    name: 'testPrerender',
    component: () => import(/* webpackChunkName: "QADetail" */ '../views/TestPrerender/index.vue')
  },
  {
    path: '*', // 客服中心首页
    name: 'default',
    component: () => import(/* webpackChunkName: "default" */ '../views/HomePage/index.vue')
  }
]

export default routes
